import React from 'react';
import Modal from './Modal';

// Справка по программе
export default function HelpModal({ onClose }) {
  return (
    <Modal title="Справка по программе" onClose={onClose}>
      <div className="help-content">
        <h4>Главная — твой дневной лимит</h4>
        <p>На главном экране видно, сколько можно потратить <b>сегодня</b>. Это главная цифра приложения.</p>
        <p>Не выходишь за неё — всё отлично. <b>Перетратил</b> — завтра лимит станет меньше. <b>Сэкономил</b> — завтра больше.</p>

        <h4>Период — твой план</h4>
        <p>Период — это отрезок времени, обычно <b>от зарплаты до зарплаты</b>. В нём указываешь:</p>
        <ul>
          <li>регулярные <b>доходы</b> — зарплата, аванс;</li>
          <li>обязательные <b>траты</b> — коммуналка, интернет, кредит.</li>
        </ul>
        <p>Приложение делит доход на дни периода и вычитает обязательные траты — получается суточный лимит.</p>

        <h4>Счета</h4>
        <p>Добавь свои карты, наличные и счета. У каждой операции указывается счёт, с которого она списана.</p>

        <h4>Траты и доходы</h4>
        <p>Вноси операции через кнопку «+» на главной: выбери тип (трата / доход / перевод / долг), счёт, категорию и сумму. Категорию можно создать прямо в форме.</p>

        <h4>Шаблоны и статистика</h4>
        <ul>
          <li><b>Шаблоны</b> — для повторяющихся операций, чтобы не вводить всё заново.</li>
          <li><b>Статистика</b> — сколько и на что ушло по категориям.</li>
        </ul>

        <h4>Приватность</h4>
        <p>🔒 Все данные хранятся только у вас и нужны только для расчётов. Мы никому их не передаём.</p>
      </div>
    </Modal>
  );
}
